import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function TrustBadges() {
  const badges = [
    { icon: FiIcons.FiShield, title: 'Lifetime Warranty', desc: 'Built for longevity' },
    { icon: FiIcons.FiTruck, title: 'Free Shipping', desc: 'Orders over $150' },
    { icon: FiIcons.FiRefreshCw, title: 'Easy Returns', desc: '30-day window' },
    { icon: FiIcons.FiAward, title: 'Ethical Sourcing', desc: 'Full-grain leather' }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 border-y border-brass/20">
      {badges.map((badge, idx) => (
        <div key={idx} className="flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-brass/10 flex items-center justify-center text-saddle mb-4">
            <SafeIcon icon={badge.icon} className="w-6 h-6" />
          </div>
          <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-navy mb-1">{badge.title}</h4>
          <p className="font-sans text-[10px] text-navy/60 uppercase tracking-tighter">{badge.desc}</p>
        </div>
      ))}
    </div>
  );
}